function Privacy() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

      <p className="mb-4">
        JobBoard is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information.
      </p>

      <h2 className="text-xl font-semibold mt-4 mb-2">1. Information We Collect</h2>
      <p className="mb-4">
        We collect personal information such as your name, email, resume, and job preferences when you register or apply for jobs.
      </p>

      <h2 className="text-xl font-semibold mt-4 mb-2">2. How We Use Your Information</h2>
      <p className="mb-4">
        We use your data to facilitate job applications, match candidates with jobs, send notifications, and improve our services.
      </p>

      <h2 className="text-xl font-semibold mt-4 mb-2">3. Sharing of Information</h2>
      <p className="mb-4">
        We may share your profile information with employers when you apply for a job. We do not sell or rent your personal data to third parties.
      </p>

      <h2 className="text-xl font-semibold mt-4 mb-2">4. Data Security</h2>
      <p className="mb-4">
        We implement security measures to protect your data. However, no system is completely secure, and we cannot guarantee absolute security.
      </p>

      <h2 className="text-xl font-semibold mt-4 mb-2">5. Cookies</h2>
      <p className="mb-4">
        Our site uses cookies to improve your experience. You can control cookies through your browser settings.
      </p>

      <h2 className="text-xl font-semibold mt-4 mb-2">6. Your Rights</h2>
      <p className="mb-4">
        You have the right to access, update, or delete your personal data. To do so, contact our support team.
      </p>

      <h2 className="text-xl font-semibold mt-4 mb-2">7. Changes to Policy</h2>
      <p className="mb-4">
        We may update this policy from time to time. Continued use of the platform implies acceptance of the revised policy.
      </p>

      <p className="mt-6 text-sm text-gray-600">
        Last updated: July 23, 2025
      </p>
    </div>
  );
}

export default Privacy;
